import { render, staticRenderFns } from "./TopLevelEntryDialog.vue?vue&type=template&id=10826f18&scoped=true"
import script from "./TopLevelEntryDialog.vue?vue&type=script&lang=js"
export * from "./TopLevelEntryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10826f18",
  null
  
)

export default component.exports